import React from "react";
import { Box, createStyles } from "@mantine/core";
import { QR, BTN_RESET } from "../theme";

// Matches the prototype's .status-seg / .yn — a single bordered segmented
// control (not a row of separate floating pills): shared background/border,
// 4px inner padding, 2px gap, and the active option filled solid.
const useStyles = createStyles(() => ({
  seg: {
    display: "inline-flex",
    background: QR.surface,
    border: `1px solid ${QR.line}`,
    borderRadius: 10,
    padding: 4,
    gap: 2,
    alignSelf: "flex-start",
  },
  btn: {
    ...BTN_RESET,
    padding: "6px 13px",
    borderRadius: 7,
    fontSize: 12.5,
    fontWeight: 600,
    color: QR.muted,
    fontFamily: "Inter",
    textAlign: "center",
  },
  // Section C's Yes/No control (.yn) uses wider horizontal padding than the
  // status/risk-type ones (.status-seg) — same shell, different button width.
  btnWide: { padding: "6px 18px" },
  btnOn: { background: QR.purple, color: "#fff" },
  btnDisabled: { cursor: "not-allowed", opacity: 0.65 },
}));

// Single-select segmented control — backs the status/risk pickers (Section
// A/B) and the Yes/No answer controls (Section C). Passing value={null}
// renders with nothing selected (the "no answer chosen" state Section C's
// Q3 uses). `wide` matches the .yn variant's wider button padding.
const PillToggle = ({ options, value, onChange, disabled, wide }) => {
  const { classes, cx } = useStyles();
  return (
    <Box className={classes.seg}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          disabled={disabled}
          className={cx(
            classes.btn,
            wide && classes.btnWide,
            value === opt.value && classes.btnOn,
            disabled && classes.btnDisabled
          )}
          onClick={() => !disabled && onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </Box>
  );
};

export default PillToggle;
